export default __webpack_public_path__ + "static/screen-1-2bb635e62b1db67c90bc699f6f2aa421.png";